var get = function(key) {
    var value;
    try {
        value = window.localStorage.getItem(key);
        return value != null ? JSON.parse(value) : undefined;
    } catch (e) {
        return value;
    }
};
var set = function(key, value) {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
        return true;
    } catch (e) {
        return false;
    }
};
var remove = function(key) {
    try {
        window.localStorage.removeItem(key);
        return true;
    } catch (e) {
        return false;
    }
};
var localStorage = {
    get: get,
    set: set,
    remove: remove
};

export { localStorage };
